import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { useEffect, useState } from "react";
import { toggleDrawer } from "../../utils/utils";
import NewButton from "../common/NewButton/NewButton";
import { CloseOutlined } from "@mui/icons-material";
import {
  Stack,
  Box,
  Typography,
  IconButton,
  FormControlLabel,
  FormGroup,
  Switch,
  alpha,
  styled,
} from "@mui/material";
import CustomSnackbar from "../common/Snackbar/CustomSnackbar";
import NewUser from "./NewUser";
import { useAccountDetails } from "../../hooks/useAccountDetails";
import "./NewUserStyles.scss";
import { UserDetailsType } from "../../types/genericType";
import { resetSelectedUser } from "../../redux/features/userSlice";
import { useDispatch } from "react-redux";
import { primary } from "../../theme/palette";

const ColoredSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: primary,
    "&:hover": {
      backgroundColor: alpha("##606ADD", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: primary,
  },
}));

type UserDrawerProps = {
  getUsersData: Function;
  openEditDrawer: boolean;
  setOpenEditDrawer: Function;
  selectedUser: UserDetailsType;
};

const UserDrawer = (props: UserDrawerProps) => {
  const { getUsersData, openEditDrawer, setOpenEditDrawer, selectedUser } =
    props;
  const [open, setOpen] = useState(false);
  const [editFlow, setEditFlow] = useState(false);
  const { accountOptions } = useAccountDetails();
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [active, setActive] = useState(selectedUser?.isActive);

  useEffect(() => {
    if (selectedUser?.id) {
      setActive(selectedUser.isActive);
    } else {
      setActive(true);
    }
  }, [selectedUser]);

  const dispatch = useDispatch();

  const handleDrawerOpen = toggleDrawer<React.KeyboardEvent | React.MouseEvent>(
    true,
    setOpen
  );
  const handleDrawerClose = () => {
    setEditFlow(false);
    setOpen(false);
    setOpenEditDrawer(false);
  };

  useEffect(() => {
    if (openEditDrawer) {
      setEditFlow(true);
      setOpen(openEditDrawer);
    }
  }, [openEditDrawer]);

  useEffect(() => {
    if (!editFlow) {
      dispatch(resetSelectedUser());
    }
  }, [editFlow]);

  const drawerComp = (
    <Stack>
      <Box className="drawer-header" role="presentation">
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          fontWeight={700}
        >
          {editFlow ? "Edit User" : "New User"}
        </Typography>
        {editFlow && (
          <FormGroup>
            <FormControlLabel
              control={
                <ColoredSwitch
                  checked={active}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setActive(event.target.checked);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label={active ? "Active" : "Inactive"}
            />
          </FormGroup>
        )}
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleDrawerClose}
          size="large"
        >
          <CloseOutlined />
        </IconButton>
      </Box>
      <NewUser
        getUsersData={getUsersData}
        setDrawerOpen={setOpen}
        accountOptions={accountOptions}
        setOnTxnSuccess={setOnSuccess}
        setSnackbarMsg={setSnackbarMsg}
        editFlow={editFlow}
        selectedUser={selectedUser}
        isActive={active}
        handleDrawerClose={handleDrawerClose}
      />
    </Stack>
  );

  return (
    <div className="transaction-drawer">
      <React.Fragment>
        <NewButton
          title="NEW USER"
          handleBtnClick={handleDrawerOpen}
          type="contained"
        />
        <Drawer
          anchor="right"
          variant="temporary"
          onClose={handleDrawerClose}
          open={open}
          sx={{
            display: { xs: "none", sm: "block" },
            "&.MuiDrawer-root .MuiDrawer-paper": {
              marginTop: "65px",
              width: "436px",
            },
          }}
        >
          {drawerComp}
        </Drawer>
        <CustomSnackbar
          open={onSuccess}
          message={snackbarMsg}
          setOpen={setOnSuccess}
        />
      </React.Fragment>
    </div>
  );
};

export default UserDrawer;
